import './IconClosePrimary.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconClosePrimary = _ref => {
  let {
    width = 24,
    height = 24,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--main-color)",
    fillRule: "nonzero",
    d: "M13.72 3.22l1.06 1.06L10.06 9l4.72 4.72-1.06 1.06L9 10.06l-4.72 4.72-1.06-1.06L7.94 9 3.22 4.28l1.06-1.06L9 7.94l4.72-4.72z"
  }));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1bbg4gd"
});
export default IconClosePrimary;